import { c as _c } from "react/compiler-runtime";
import { markWaveReadFromCache, useClearWaveReadStateOnAddressChange, useClearWaveReadStateOnLastUnmount, useSyncWaveReadVerifiedIdentityCaches, useWaveReadCacheRefs } from "@/hooks/useMarkWaveNotificationsRead.cache";
import { useWaveReadIdentityState } from "@/hooks/useMarkWaveNotificationsRead.identity";
import type { MarkWaveNotificationsReadOptions, MarkWaveNotificationsReadResult, WaveNotificationsReadMarkerConfig, WaveNotificationsReadMarkerState, WaveReadAddressEpoch } from "@/hooks/useMarkWaveNotificationsRead.types";
import { useCallback, useMemo } from "react";
export type { MarkWaveNotificationsReadOptions, MarkWaveNotificationsReadResult, WaveNotificationsReadMarkerState } from "@/hooks/useMarkWaveNotificationsRead.types";
export const useWaveNotificationsReadMarkerState = t0 => {
  const $ = _c(28);
  const {
    address,
    connectedProfileId,
    activeProfileProxyId,
    activeProfileProxyCreatorId,
    walletAuth,
    invalidateNotifications
  } = t0;
  let t1;
  if ($[0] !== activeProfileProxyCreatorId || $[1] !== activeProfileProxyId || $[2] !== address || $[3] !== connectedProfileId || $[4] !== walletAuth) {
    t1 = {
      address,
      connectedProfileId,
      activeProfileProxyId,
      activeProfileProxyCreatorId,
      walletAuth
    };
    $[0] = activeProfileProxyCreatorId;
    $[1] = activeProfileProxyId;
    $[2] = address;
    $[3] = connectedProfileId;
    $[4] = walletAuth;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const identityState = useWaveReadIdentityState(t1);
  const {
    addressKey,
    activeProfileProxyId: currentProfileProxyId,
    identityKey,
    proxyRoleIdentityKey,
    temporaryProxyRoleIdentity,
    verifiedIdentity
  } = identityState;
  let t2;
  if ($[6] !== addressKey) {
    t2 = {
      addressKey
    };
    $[6] = addressKey;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const addressEpoch = t2;
  let t3;
  if ($[8] !== addressEpoch || $[9] !== identityKey || $[10] !== invalidateNotifications || $[11] !== temporaryProxyRoleIdentity || $[12] !== verifiedIdentity) {
    t3 = {
      addressEpoch,
      identityKey,
      temporaryProxyRoleIdentity,
      verifiedIdentity,
      invalidateNotifications
    };
    $[8] = addressEpoch;
    $[9] = identityKey;
    $[10] = invalidateNotifications;
    $[11] = temporaryProxyRoleIdentity;
    $[12] = verifiedIdentity;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const cacheRefs = useWaveReadCacheRefs(t3);
  let t4;
  if ($[14] !== cacheRefs || $[15] !== verifiedIdentity || $[16] !== walletAuth) {
    t4 = {
      walletAuth,
      verifiedIdentity,
      cacheRefs
    };
    $[14] = cacheRefs;
    $[15] = verifiedIdentity;
    $[16] = walletAuth;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  useSyncWaveReadVerifiedIdentityCaches(t4);
  useClearWaveReadStateOnAddressChange(addressKey);
  useClearWaveReadStateOnLastUnmount(addressKey);
  let t5;
  if ($[18] !== addressEpoch || $[19] !== addressKey || $[20] !== cacheRefs || $[21] !== currentProfileProxyId || $[22] !== identityKey) {
    t5 = (waveId, options) => markWaveReadFromCache({
      waveId,
      addressKey,
      activeProfileProxyId: currentProfileProxyId,
      identityKey,
      addressEpoch,
      cacheRefs,
      options
    });
    $[18] = addressEpoch;
    $[19] = addressKey;
    $[20] = cacheRefs;
    $[21] = currentProfileProxyId;
    $[22] = identityKey;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  const markWaveNotificationsRead = t5;
  let t6;
  if ($[24] !== identityKey || $[25] !== markWaveNotificationsRead || $[26] !== proxyRoleIdentityKey) {
    t6 = {
      markWaveNotificationsRead,
      identityKey,
      proxyRoleIdentityKey
    };
    $[24] = identityKey;
    $[25] = markWaveNotificationsRead;
    $[26] = proxyRoleIdentityKey;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  return t6;
};